import React from 'react';

import { Toggle } from 'rsuite';

import './styles.css';
import { useCustomTheme } from '../../hooks/useCustomTheme';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').ToggleProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomToggle({ ...rest }) {
  const { theme, themeSchema } = useCustomTheme();

  return (
    <Toggle
      className="custom-toggle"
      style={{
        '--toggle-unchecked-color':
          themeSchema === 'light'
            ? theme.colors.lightGray
            : theme.colors.backgroundSecondary,
      }}
      {...rest}
    />
  );
}
